import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { ReactNode } from 'react';

export interface EyebrowProps {
  children: ReactNode;
  /** Text color override (defaults to the muted secondary tone). */
  color?: string;
  /** Render as this element (e.g. 'div' inside a heading context). */
  component?: React.ElementType;
  sx?: React.ComponentProps<typeof Box>['sx'];
}

/** Small uppercase monospace label used above section headings. */
export function Eyebrow({ children, color, component = 'span', sx }: EyebrowProps) {
  const theme = useTheme();
  const t = theme.palette.tactical;
  return (
    <Box
      component={component}
      sx={{
        fontFamily: t.monoFont,
        fontSize: 11,
        letterSpacing: '0.14em',
        color: color || t.dim,
        textTransform: 'uppercase',
        display: 'inline-block',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export default Eyebrow;
